module.exports = __webpack_public_path__ + "static/media/cases_3d_05a.d0644948.jpg";